import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57381879"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-opacity tr_row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { style: {"flex":"2"} }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import { Slider } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'ElementOpacity',
  setup(__props) {

const { t, locale } = useI18n()

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const opacity = ref<number>(1)

watch(handleElement, () => {
  if (!handleElement.value) return
  opacity.value = 'opacity' in handleElement.value && handleElement.value.opacity !== undefined ? handleElement.value.opacity : 1
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateOpacity = (value: number) => {
  if (!handleElement.value) return
  const props = { opacity: value }
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementOpacity.opacity`)) + "：", 1),
      _createVNode(_unref(Slider), {
        class: "slider",
        min: 0,
        max: 1,
        step: 0.1,
        value: opacity.value,
        onChange: _cache[0] || (_cache[0] = value => updateOpacity(value as number))
      }, null, 8, ["step", "value"])
    ])
  ]))
}
}

})